<script lang="ts">
    import TemplateSettingsGeneral from "./TemplateSettingsGeneral.svelte";
    import {_} from 'svelte-i18n';
    import {customerSettings} from '../../../stores/api';
    import SettingsRowNumber from "./SettingsRowNumber.svelte";
    import {z} from "zod";
    import SelectHour from "../../shared/SelectHour.svelte";
    import SettingsRow from "./SettingsRow.svelte";
    import SettingsRowLabel from "./SettingsRowLabel.svelte";
    import SettingsRowValue from "./SettingsRowValue.svelte";

    export let update: () => void;

    let error: string = '';

    function validator(data: unknown) {
        return z.coerce.number().int().min(0).max(60).safeParse(data);
    }

</script>


<TemplateSettingsGeneral>
    <div slot="label">{$_('Planning')}</div>
    <div slot="content">
        <div class="settings-group" class:error={error!==''}>
            <SettingsRow>
                <SettingsRowLabel>
                    {$_('Default start time for planned routes')}
                </SettingsRowLabel>
                <SettingsRowValue>
                    <SelectHour
                        bind:hour={$customerSettings.planning.start_time_route}
                        onChange={(selected)=>{update(); return true;}}
                        withBorder={false}
                    />
                </SettingsRowValue>
            </SettingsRow>
        </div>
    </div>
</TemplateSettingsGeneral>

